import { Placement, ToastLevel, ToastType, Type } from '@philips-internal/oswald-ui-constants';
import { ReactElement } from 'react';
import { ToastService } from '@philips-internal/oswald-ui-components';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { DefaultToastNotificationProps } from '../interfaces/toast-notification-props';
import { ToastResponse } from '../interfaces/ToastResponse';

export const DEFAULT_TIMEOUT = {
  LONG: 7000,
  MEDIUM: 5000,
  NONE: 0,
  SHORT: 3000,
}

export function getToastLevel(type: Type): ToastLevel {
  switch (type) {
    case Type.DANGER: return ToastLevel.ERROR;
    case Type.SAFETY: return ToastLevel.SUCCESS;
    default: return ToastLevel.WARNING;
  }
}

export function showToastNotification(props: DefaultToastNotificationProps): string {
  const { action, highlight, level, message, timeout = DEFAULT_TIMEOUT.MEDIUM, title, toastType = ToastType.BUBBLE, id, placement = Placement.BOTTOM} = props;
  const toastId = id ?? generateUUID();

  ToastService.open({
    action,
    dismissible: true,
    highlight,
    id: toastId,
    level,
    message: message,
    offset: 0,
    showIcon: true,
    timeout,
    title,
    type: toastType,
    placement,
  });

  return toastId;
}

export function showToastNotificationSuccess(message: string, timeout?: number, highlight?: boolean, title?: string, action?: ReactElement): string {
  return showToastNotification({ action, highlight, level: ToastLevel.SUCCESS, message, timeout, title });
}

export function showToastNotificationInformation(message: string, timeout?: number, highlight?: boolean, title?: string, action?: ReactElement): string {
  return showToastNotification({ action, highlight, level: ToastLevel.INFORMATION, message, timeout, title });
}

export function showToastNotificationWarning(message: string, timeout?: number, highlight?: boolean, title?: string, action?: ReactElement): string {
  return showToastNotification({ action, highlight, level: ToastLevel.WARNING, message, timeout, title });
}

export function showToastNotificationCaution(message: string, timeout?: number, highlight?: boolean, title?: string, action?: ReactElement): string {
  return showToastNotification({ action, highlight, level: ToastLevel.CAUTION, message, timeout, title });
}

export function showToastNotificationError(message: string, timeout?: number, highlight?: boolean, title?: string, action?: ReactElement): string {
  return showToastNotification({ action, highlight, level: ToastLevel.ERROR, message, timeout, title });
}

export function closeToastNotification(toastId: string): void {
  ToastService.close(toastId);
}

export function forEachMessageShowToast(toastResponse: ToastResponse): void {
  if (!toastResponse) {
    return;
  }

  let messages = toastResponse.messages;
  let toastLevel = String(toastResponse.type).toLocaleLowerCase() as Type;

  if (!toastLevel && !messages) {
    messages = ['results.happened.request'];
    toastLevel = Type.DANGER;
  }

  messages.forEach(message => {
    showToastNotification({ highlight: false, level: getToastLevel(toastLevel), message });
  });
}
